import type { Command } from "commander";
import { getValidIdToken } from "../lib/user-config-store.js";

interface PrintDeps {
  getToken: () => Promise<string>;
  stdout: (s: string) => void;
  stderr: (s: string) => void;
}

// Pure-ish core for testing. Returns the intended exit code.
export async function runPrintIdToken(deps: PrintDeps): Promise<number> {
  try {
    deps.stdout(await deps.getToken());
    return 0;
  } catch (err) {
    deps.stderr(`print-id-token: ${err instanceof Error ? err.message : String(err)}`);
    return 1;
  }
}

export function registerPrintIdTokenCommand(program: Command): void {
  program
    .command("print-id-token", { hidden: true })
    .description("Print a fresh, verified NAL id_token to stdout (used by hooks)")
    .action(async () => {
      const code = await runPrintIdToken({
        getToken: getValidIdToken,
        stdout: (s) => process.stdout.write(s),
        stderr: (s) => process.stderr.write(`${s}\n`),
      });
      process.exit(code);
    });
}
